import { DragDataTypes, getStringField, type DragData } from '@modules/drag-n-drop/types/drag-data';

/** Matches `ProjectFormComponent.tabs`'s board-tab entry (`{ title: 'Tasks', value: 'project' }`). */
export const PROJECT_BOARD_TAB = 'project';

/** Only tasks already owned by this project use its board's structural targets. */
export function isBoardTabTaskDrop(
  selectedTab: string,
  dragData: DragData,
  project: { readonly id?: string; readonly accountId?: string },
): boolean {
  return selectedTab === PROJECT_BOARD_TAB && dragData.type === DragDataTypes.task &&
    !!project.id && !!project.accountId && dragData.data.length > 0 && dragData.data.every(item =>
      getStringField(item, 'projectId') === project.id && getStringField(item, 'accountId') === project.accountId);
}
